export type ToolStatus = 'live' | 'beta' | 'soon';
export type ToolAudience = 'Staff' | 'Client';

export type Tool = {
  id: string;
  name: string;
  mono: string;
  tagline: string;
  desc: string;
  status: ToolStatus;
  audience: ToolAudience[];
  updated: string;
  featured?: boolean;
  accent?: string;
  href?: string;
  /**
   * App-role names (per the tool's own Nexus registration role_map) that grant
   * access. Undefined or empty = visible to anyone signed in.
   * Used to grey out tiles a user lacks access to.
   */
  requiredAppRoles?: string[];
};

export const TOOLS: readonly Tool[] = [
  {
    id: 'nexus',
    name: 'Nexus',
    mono: 'N',
    tagline: 'The platform Jones + Palmer runs on',
    desc: 'Nexus is the operating system Jones + Palmer runs on — and where you can now see exactly what’s happening on your work, in real time.',
    status: 'live',
    audience: ['Staff', 'Client'],
    updated: '02 May 26',
    featured: true,
    accent: '#1C4DFF',
    href: 'https://nexus.jp.tools',
  },
  {
    id: 'glassbox',
    name: 'Glass Box',
    mono: 'G',
    tagline: 'Accessibility review for annual reports',
    desc: 'Score, diagnose and remediate WCAG issues in your annual report PDF, microsite or interactive document.',
    status: 'live',
    audience: ['Staff', 'Client'],
    updated: '28 Apr 26',
    href: 'https://glassbox.jp.tools',
  },
  {
    id: 'iro',
    name: 'IRO Assistant',
    mono: 'I',
    tagline: 'Investor-relations answer engine',
    desc: 'A chat layer trained on your published disclosures that answers stakeholder questions on your website.',
    status: 'beta',
    audience: ['Staff', 'Client'],
    updated: '30 Apr 26',
    href: 'https://www.jonesandpalmer.co.uk/',
  },
  {
    id: 'arwf',
    name: 'AR Wireframer',
    mono: 'A',
    tagline: 'Annual report structure & flow',
    desc: 'Sketch next year’s report — sections, narrative arc and content density — before a page is designed.',
    status: 'soon',
    audience: ['Staff'],
    updated: '—',
  },
  {
    id: 'brand',
    name: 'Brand Assessor',
    mono: 'B',
    tagline: 'Comprehensive brand review',
    desc: 'Audit a brand’s clarity, consistency and stakeholder fit across digital, print and live channels.',
    status: 'soon',
    audience: ['Staff', 'Client'],
    updated: '—',
  },
  {
    id: 'pulse',
    name: 'Pulse',
    mono: 'P',
    tagline: 'Stakeholder sentiment tracking',
    desc: 'A continuous read of investor, employee and media sentiment around your reporting moments.',
    status: 'soon',
    audience: ['Staff', 'Client'],
    updated: '—',
  },
  {
    id: 'compass',
    name: 'Compass',
    mono: 'C',
    tagline: 'Reporting framework navigator',
    desc: 'A guided map across CSRD, IFRS S1/S2, TCFD and emerging standards, with materiality at the centre.',
    status: 'soon',
    audience: ['Staff', 'Client'],
    updated: '—',
  },
  {
    id: 'forge',
    name: 'Forge',
    mono: 'F',
    tagline: 'Disclosure drafting workspace',
    desc: 'Co-write disclosures with the J+P house style, embedded review trails and source-of-truth linking.',
    status: 'soon',
    audience: ['Staff'],
    updated: '—',
  },
];
